import React, { useRef, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

/* Colours: text #4e5356 | buttons #2596be | headings #4573a6 | background white
   Fonts  : Ubuntu Bold (headings) / Open Sans Regular (body) */

const STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Ubuntu:wght@700&display=swap");

.hp{--head:#4573a6;--btn:#2596be;--tint:#eef6fa;--line:#d3e4ed;
  background:#fff;padding:80px 24px;font-family:"Open Sans",sans-serif;font-weight:400}
.hp-box{--mx:50%;--my:50%;position:relative;overflow:hidden;max-width:1240px;margin:0 auto;padding:70px 40px;text-align:center;border-radius:32px;color:#fff;
  background:linear-gradient(120deg,var(--head),var(--btn));box-shadow:0 30px 60px -34px rgba(37,150,190,.8)}
.hp-box::before{content:"";position:absolute;inset:0;pointer-events:none;
  background-image:radial-gradient(rgba(255,255,255,.14) 1.2px,transparent 1.2px);background-size:26px 26px;
  -webkit-mask-image:linear-gradient(180deg,#000,transparent 80%);mask-image:linear-gradient(180deg,#000,transparent 80%)}
.hp-box::after{content:"";position:absolute;width:320px;height:320px;border-radius:50%;right:-90px;top:-140px;background:rgba(255,255,255,.18);filter:blur(50px);pointer-events:none}
.hp-glow{position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .35s;
  background:radial-gradient(300px circle at var(--mx) var(--my),rgba(255,255,255,.2),transparent 70%)}
.hp-box:hover .hp-glow{opacity:1}
.hp-box>*{position:relative;z-index:1}

.hp-chip{display:inline-block;margin-bottom:16px;padding:6px 18px;border-radius:50px;background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.35);
  font-size:12px;letter-spacing:2px;text-transform:uppercase;color:#fff}
.hp h2{margin:0 0 14px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:42px;line-height:1.15;color:#fff;cursor:default;transition:letter-spacing .35s}
.hp h2:hover{letter-spacing:.6px}
.hp-sub{display:flex;align-items:center;justify-content:center;gap:12px;margin-bottom:34px}
.hp-sub i{display:block;height:2px;width:40px;border-radius:2px;background:rgba(255,255,255,.7)}
.hp-sub p{margin:0;font-size:15px;line-height:1.75;color:rgba(255,255,255,.92)}

/* button: white, fills with dark blue on hover */
.hp-btn{position:relative;overflow:hidden;z-index:0;display:inline-flex;align-items:center;gap:8px;padding:13px 32px;border:none;border-radius:50px;
  background:#fff;color:var(--head);font-family:"Open Sans",sans-serif;font-weight:600;font-size:14px;cursor:pointer;
  transition:color .35s,transform .35s cubic-bezier(.3,1.6,.5,1),box-shadow .35s}
.hp-btn::before{content:"";position:absolute;inset:0;z-index:-1;background:#2f4d75;transform:translateX(-101%);transition:transform .45s cubic-bezier(.2,.8,.2,1)}
.hp-btn:hover{color:#fff;transform:translateY(-3px);box-shadow:0 18px 30px -12px rgba(0,0,0,.45)}
.hp-btn:hover::before{transform:none}
.hp-btn span{display:inline-block;transition:transform .35s}
.hp-btn:hover span{transform:translateX(5px)}

/* entrance */
.hp:not(.in) .hp-box{opacity:0;transform:translateY(50px)}
.hp.in .hp-box{animation:hpRise .8s cubic-bezier(.2,.8,.2,1) backwards}
@keyframes hpRise{from{opacity:0;transform:translateY(50px)}}

@media(max-width:600px){
  .hp{padding:60px 16px}
  .hp-box{padding:48px 22px;border-radius:26px}
  .hp h2{font-size:30px}
  .hp-sub i{display:none}
}
@media(prefers-reduced-motion:reduce){
  .hp *,.hp *::before,.hp *::after{animation:none!important;transition:none!important}
  .hp:not(.in) .hp-box{opacity:1;transform:none}
}
`;

const Help = () => {
  const history = useHistory();
  const sectionRef = useRef(null);
  const boxRef = useRef(null);
  const [inView, setInView] = useState(false);

  // animate in when scrolled into view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // spotlight follows the mouse
  const handleMove = (e) => {
    const el = boxRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--mx", e.clientX - r.left + "px");
    el.style.setProperty("--my", e.clientY - r.top + "px");
  };

  return (
    <div className={"hp helpContainer" + (inView ? " in" : "")} ref={sectionRef}>
      <style>{STYLES}</style>

      <div className="hp-box" ref={boxRef} onMouseMove={handleMove}>
        <div className="hp-glow" />
        <div className="hp-chip">Let's Talk</div>
        <h2>Let Us Help You Towards the Growth</h2>
        <div className="hp-sub">
          <i />
          <p>We Are Here To Build The Next Big Thing For You</p>
          <i />
        </div>
        <button className="hp-btn" onClick={() => history.push("/contact")}>
          Let's Have a Talk <span>→</span>
        </button>
      </div>
    </div>
  );
};

export default Help;